import { createAction, props } from '@ngrx/store';
import { IOutstandingResponse } from '../models/outstanding.model';

export const loadOutstanding = createAction(
  '[Outstanding] Load Outstanding',
  props<{ businessId: string; businessPaymentRunId: string }>()
);

export const loadOutstandingSuccess = createAction(
  '[Outstanding] Load Outstanding Success',
  props<{ response: IOutstandingResponse }>()
);

export const loadOutstandingFailure = createAction(
  '[Outstanding] Load Outstanding Failure',
  props<{ error: any }>()
);
